import { API_URL } from "./constant";


export async function refreshAccessToken() {
  const refreshToken = JSON.parse(localStorage.getItem("refreshToken"));

  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  const response = await fetch(`${API_URL}/token/refresh/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ refresh: refreshToken }),
  });

  if (!response.ok) {
    throw new Error("Failed to refresh access token");
    
  }

  const data = await response.json();
  localStorage.setItem("accessToken", JSON.stringify(data.access));
  localStorage.setItem("refreshToken", JSON.stringify(data.refresh));
  return data.access;
}
